/**
 * Created by USER on 18/4/16.
 */
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {changeBarState, changeLanguage, changeOffsetWidth} from '../redux/actions/headerbar_action';

class AppBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: '',
      mobileMenu: null,
      headBg: null,
      top: 0,
      mobileMenuShow: null,
      zIndex: 'block',
      iconName: 'icon-Artboard',
      headerPosition: 'inherit',
      appName: null,
      language: this.props.t('language'),
    };
  }
  componentWillMount() {
    const {appBarReducer, i18n} = this.props;
    i18n.changeLanguage(appBarReducer.language);
    this.props.dispatch(changeBarState(appBarReducer.appbarState));
  }

  componentDidMount() {
    const {offsetWidth} = document.body;
    this.setState({ // 判断app是否为博客的app
      appName: window.appName,
      type: this.props.appBarReducer.appbarState
    });
    this.props.dispatch(changeOffsetWidth(offsetWidth));
    if (offsetWidth > 768) { // 页面加载完毕设置一些基本state
      this.setState({
        zIndex: 'block',
        offsetWidth,
        headerPosition: 'inherit'
      });
    } else {
      this.setState({
        zIndex: 'none',
        offsetWidth,
        headerPosition: 'fixed'
      });
    }
    window.addEventListener('scroll', () => { // 浏览器滚动时，导航栏的动画切换
      const {offsetWidth} = document.body;
      const sTop = document.documentElement.scrollTop + document.body.scrollTop;
      const {appbarState} = this.props.appBarReducer;
      if (appbarState !== false) {
        this.setState({
          type: appbarState
        })
      }
      this.props.dispatch(changeBarState(appbarState));
      if (offsetWidth > 768) {
        if (sTop === 0) {
          this.props.dispatch(changeBarState(this.state.type));
          this.setState({
            mobileMenu: false,
            headBg: null,
            top: sTop,
            zIndex: 'block',
            headerPosition: 'inherit'
          });
        } else if (sTop > 0) { // 浏览器stop负数的兼容
          const {headBg} = this.state;
          this.setState({
            mobileMenu: true,
            top: sTop,
            headerPosition: 'fixed'
          });
          if (headBg === false) {
            this.setState({
              headBg: true
            })
          }
        }
      }
    });
    window.addEventListener('resize', () => { // 浏览器缩放时，导航栏的变化
      const {offsetWidth} = document.body;
      const sTop = document.documentElement.scrollTop + document.body.scrollTop;
      const {appbarState} = this.props.appBarReducer;
      this.props.dispatch(changeBarState(appbarState));
      this.props.dispatch(changeOffsetWidth(offsetWidth));
      if (offsetWidth < 768) {
        this.setState({
          zIndex: 'none',
          mobileMenu: null,
          offsetWidth,
          headerPosition: 'fixed'
        })
      } else {
        this.setState({
          zIndex: 'block',
          offsetWidth
        });
        if (sTop === 0) {
          this.setState({
            mobileMenu: false,
            headBg: null,
            top: sTop,
            zIndex: 'block',
            headerPosition: 'inherit'
          });
        } else if (sTop > 0) { // 浏览器stop负数的兼容
          const {headBg} = this.state;
          this.setState({
            mobileMenu: true,
            top: sTop,
            headerPosition: 'fixed'
          });
          if (headBg === false) {
            this.setState({
              headBg: true
            })
          }
        }
      }
    })
  }

  changeLanguage(lng) { // 切换中英文
    const { i18n } = this.props;
    i18n.changeLanguage(lng);
    this.props.dispatch(changeLanguage(lng));
    this.setState({
      language: lng
    });
    document.cookie = `language = ${lng}; domain=lubanso.com;`;
  }

  checkNavContent(type) { // check哪一个导航栏的的样式变化
    const sTop = document.documentElement.scrollTop + document.body.scrollTop;
    const {offsetWidth} = document.body;
    if (type !== 'language') {
      this.props.dispatch(changeBarState(type));
      this.setState({
        type,
      });
    }
    if (offsetWidth > 768) {
      if (sTop > 0) {
        this.setState({
          mobileMenu: true,
          mobileMenuShow: false
        });
        setTimeout(() => {
          this.setState({
            zIndex: 'none'
          })
        }, 500)
      }
    } else {
      this.setState({
        mobileMenu: true,
        mobileMenuShow: false
      });
      setTimeout(() => {
        this.setState({
          zIndex: 'none'
        })
      }, 500)
    }
  }

  showNav() { // mobile 打开导航栏
    this.props.dispatch(changeBarState(false));
    this.setState({
      mobileMenu: false,
      headBg: false,
      zIndex: 'block',
      navColor: true
    });
  }

  mobileMenu() {
    const {mobileMenu} = this.state;
    if (mobileMenu === false) { // web情况下， 点击出现和收起的动画
      this.setState({
        mobileMenu: true,
        mobileMenuShow: false,
      });
      setTimeout(() => {
        this.setState({
          zIndex: 'none'
        })
      }, 500)
    } else {
      this.setState({
        mobileMenu: false,
        mobileMenuShow: false,
        zIndex: 'block'
      });
    }
  }

  routerWay(route) { // 不同域名下的不同跳转的方式
    if (window.appName === 'blog') {
      window.event?window.event.cancelBubble=true:event.stopPropagation();
      window.location.href=`https://www.lubanso.com/${route}`
    }
  }

  render() {
    const { t } = this.props;
    const {mobileMenu, headBg, top, zIndex, iconName, type, headerPosition, appName, language} = this.state;

    // 导航栏的根据不同的状态 切换动画效果
    const MenuClassName =  mobileMenu === null ? ' ' : (mobileMenu ? 'mobile_menu_translate_out' : 'mobile_menu_translate_hidden');
    // const liClassName1 = mobileMenu === null ? ' ' : (mobileMenu ? 'nav_content_translate_hidden1' : 'nav_content_translate_out1');
    const liClassName2 = mobileMenu === null ? ' ' : (mobileMenu ? 'nav_content_translate_hidden2' : 'nav_content_translate_out2');
    const liClassName3 = mobileMenu === null ? ' ' : (mobileMenu ? 'nav_content_translate_hidden3' : 'nav_content_translate_out3');
    const liClassName4 = mobileMenu === null ? ' ' : (mobileMenu ? 'nav_content_translate_hidden4' : 'nav_content_translate_out4');
    const liClassName5 = mobileMenu === null ? ' ' : (mobileMenu ? 'nav_content_translate_hidden5' : 'nav_content_translate_out5');
    const liClassName6 = mobileMenu === null ? ' ' : (mobileMenu ? 'nav_content_translate_hidden6' : 'nav_content_translate_out6');
    const liClassName7 = mobileMenu === null ? ' ' : (mobileMenu ? 'nav_content_translate_hidden7' : 'nav_content_translate_out7');
    const liClassName8 = mobileMenu === null ? ' ' : (mobileMenu ? 'nav_content_translate_hidden8' : 'nav_content_translate_out8');
    const navBackgroundAnimation = mobileMenu === null ? ' ' : (mobileMenu ? 'nav_content_background_translate_hidden' : 'nav_content_background_translate_out');
    const navBackgroundAnimation2 = mobileMenu === null ? ' ' : (mobileMenu ? 'nav_content_background_translate_hidden2' : 'nav_content_background_translate_out2');
    const navBackgroundAnimation3 = mobileMenu === null ? ' ' : (mobileMenu ? 'nav_content_background_translate_hidden3' : 'nav_content_background_translate_out3');
    const headBgAnimation = {
      animation: headBg === null ? ' ' : (mobileMenu ? 'headerBgHidden 0.5s 1' : 'headerBgShow 0.5s 1'),
      backgroundPosition: headBg === null ? ' ' : (mobileMenu ? '0 100%' : '0 0%')
    };
    return (
      <div
        className="header-navigation"
        style={{
          position: headerPosition ,
          animation: headBgAnimation.animation,
          backgroundPosition: headBgAnimation.backgroundPosition
        }}
      >
        <div className="header-navigation_content">
          <div
            className="nav_logo"
            onClick={() => {this.checkNavContent('home_page');}}
            onKeyPress={() => {this.checkNavContent('home_page');}}
          >
            {
              appName !== 'blog' ?
                <Link to="/">
                  <i
                    className="logo_name icon iconfont icon-english"
                    style={{color: 'rgba(0, 0, 0, 0.8)'}}
                    onClick={() => this.routerWay('')}
                  />
                </Link> :
                <a href="https://www.lubanso.com">
                  <i
                    className="logo_name icon iconfont icon-english"
                    style={{color: 'rgba(0, 0, 0, 0.8)'}}
                    onClick={() => this.routerWay('')}
                  />
                </a>
            }
          </div>
          <div
            className={`mobile_menu ${MenuClassName}`}
            onClick={() => this.showNav()}
            onMouseOver={() => this.setState({iconName: 'icon-ArtboardCopy1'})}
            onMouseLeave={() => this.setState({iconName: 'icon-Artboard'})}
          >
            <i className={`icon iconfont ${iconName}`} />
          </div>
          <div
            className="nav_content"
            style={{display: zIndex}}
          >
            <div className="mobile_nav_content_background">
              <span className={`${navBackgroundAnimation}`} />
              <span className={`${navBackgroundAnimation2}`} />
              <span className={`${navBackgroundAnimation3}`} />
            </div>
            <ul>
              <li
                className={`${liClassName2}`}
                style={{opacity: top > 0 ? 0 : 1}}
              >
                {
                  appName !== 'blog' ?
                    <Link to="/X1">
                      <span
                        onClick={() => {this.checkNavContent('X1'); this.routerWay('X1')}}
                        onKeyPress={() => {this.checkNavContent('X1'); this.routerWay('X1')}}
                        style={{color: type === 'X1' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.45)'}}
                      >
                        X1
                      </span>
                    </Link> :
                    <a href="https://www.lubanso.com/x1">
                       <span
                         onClick={() => {this.checkNavContent('X1'); this.routerWay('X1')}}
                         onKeyPress={() => {this.checkNavContent('X1'); this.routerWay('X1')}}
                         style={{color: type === 'X1' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.45)'}}
                       >
                        X1
                      </span>
                    </a>
                }
              </li>
              <li
                className={`${liClassName3}`}
                style={{opacity: top > 0 ? 0 : 1}}
              >
                {
                  appName !== 'blog' ?
                    <Link to="/download">
                      <span
                        onClick={() => {this.checkNavContent('download'); this.routerWay('download')}}
                        onKeyPress={() => {this.checkNavContent('download'); this.routerWay('download')}}
                        style={{color: type === 'download' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.45)'}}
                      >
                        {t('head_download')}
                      </span>
                    </Link> :
                    <a href="https://www.lubanso.com/download">
                       <span
                         onClick={() => {this.checkNavContent('download'); this.routerWay('download')}}
                         onKeyPress={() => {this.checkNavContent('download'); this.routerWay('download')}}
                         style={{color: type === 'download' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.45)'}}
                       >
                         {t('head_download')}
                      </span>
                    </a>
                }
              </li>
              <li
                className={`${liClassName5}`}
                style={{opacity: top > 0 ? 0 : 1}}
              >
                {/* {
                  appName !== 'blog' ?
                    <Link to="/affiliates">
                      <span
                        onClick={() => {this.checkNavContent('affiliates'); this.routerWay('affiliates')}}
                        onKeyPress={() => {this.checkNavContent('affiliates'); this.routerWay('affiliates')}}
                        style={{color: type === 'affiliates' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.45)'}}
                      >
                        {t('head_affiliate')}
                      </span>
                    </Link> :
                    <a href="https://www.lubanso.com/affiliates">
                        <span
                          onClick={() => {this.checkNavContent('affiliates'); this.routerWay('affiliates')}}
                          onKeyPress={() => {this.checkNavContent('affiliates'); this.routerWay('affiliates')}}
                          style={{color: type === 'affiliates' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.45)'}}
                        >
                        {t('head_affiliate')}
                      </span>
                    </a>
                } */}
              </li>
              <li
                className={`${liClassName6}`}
                style={{opacity: top > 0 ? 0 : 1}}
              >
                {
                  appName !== 'blog' ?
                    <Link to="/announcement">
                      <span
                        onClick={() => {this.checkNavContent('announcement'); this.routerWay('announcement')}}
                        onKeyPress={() => {this.checkNavContent('announcement'); this.routerWay('announcement')}}
                        style={{color: type === 'announcement' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.45)'}}
                      >
                        {t('head_notice')}
                      </span>
                    </Link> :
                    <a href="https://www.lubanso.com/announcement">
                      <span
                        onClick={() => {this.checkNavContent('announcement'); this.routerWay('announcement')}}
                        onKeyPress={() => {this.checkNavContent('announcement'); this.routerWay('announcement')}}
                        style={{color: type === 'announcement' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.45)'}}
                      >
                        {t('head_notice')}
                      </span>
                    </a>
                }
              </li>
              <li
                className={`${liClassName7}`}
                style={{
                  opacity: top > 0 ? 0 : 1
                }}
              >
                <a href="https://support.lubanso.com" target="_Blank">
                  <span
                    style={{
                      color: type === 'help' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.45)',
                    }}
                  >
                   {t('head_help')}
                  </span>
                </a>
              </li>
              <li
                className={`${liClassName8} language`}
                style={{
                  opacity: top > 0 ? 0 : 1
                }}
              >
                <span
                  onClick={() => {this.changeLanguage('zh'); this.checkNavContent('language')}}
                  style={{
                    color: language === 'zh' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.45)',
                  }}
                >中</span>
                /
                <span
                  style={{
                    color: language === 'en' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.45)',
                  }}
                  onClick={() => {this.changeLanguage('en'); this.checkNavContent('language')}}
                >EN</span>
              </li>
            </ul>
          </div>
          <div
            className="nav_bars"
            onClick={() => this.mobileMenu()}
            onKeyPress={() => this.mobileMenu}
          >
            <i className="icon iconfont icon-Artboard" />
          </div>
        </div>
      </div>
    );
  }
}

// {/*<div className="language_switching">*/}
//   {/*<Dropdown overlay={languageMenu} trigger={['click']}>*/}
//     {/*<a className="ant-dropdown-link">*/}
//       {/*<img*/}
//         {/*className="national_flag"*/}
//         {/*src={t('language') === 'English' ? ImgList.img.en : ImgList.img.zh}*/}
//         {/*alt="LUBANSO"*/}
//       {/*/>*/}
//       {/*<span className="national_name">*/}
//                 {/*{*/}
//                   {/*t('language') === 'English' ? 'English' : '中文'*/}
//                 {/*}*/}
//               {/*</span>*/}
//     {/*</a>*/}
//   {/*</Dropdown>*/}
// {/*</div>*/}
function select(state) {
  return {
    appBarReducer: state.appBarReducer
  };
}

const appBar = connect(select)(AppBar);
export default translate('translations')(appBar);
